// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings'))
  theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    // Optional
    loadProductFirst: false,
    styleScrollToTop: 'style2',
    defaultDisplay: boostPFSThemeConfig.custom.layout,
    showPlaceholderProductList: true,
    showVariantImageBasedOnSelectedFilter: 'pf_opt_color',
    filterTreeMobileStyle: 'style1',
    collapseOnMobileByDefault: false,
    enableAjaxCart: false,
  },
};

(function () {
  BoostPFS.inject(this);

  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add a specific class for grid item
    var itemGridWidthClass = '';
    var imageSize = '600x600';

    switch (boostPFSConfig.custom.products_per_row) {
      case 2:
        itemGridWidthClass = 'medium-up--one-half';
        imageSize = '540x600';
        break;
      case 3:
        itemGridWidthClass = 'small--one-half medium-up--one-third';
        imageSize = '345x550';
        break;
      case 4:
        itemGridWidthClass = 'small--one-half medium-up--one-quarter';
        imageSize = '250x';
        break;
      case 5:
        itemGridWidthClass = 'small--one-half medium-up--one-fifth';
        imageSize = '195x';
        break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    var imgId = 'ProductCardImage-' + data.id;
    var wrapperId = 'ProductCardImageWrapper-' + data.id;

    // Build Image style
    var imageStyle = buildImageStyle(data);
    itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

    // Add Images
    var aspect_ratio = '';
    var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
    itemImagesHtml += '<div style="padding-top:';
    if (images.length > 0) {
      aspect_ratio = images[0]['width'] / images[0]['height'];

      // fix mobile
      if ($(window).width() <= 750) {
        aspect_ratio = 0.72;
      }

      itemImagesHtml += (1 / aspect_ratio) * 100;
    } else {
      itemImagesHtml += 100;
    }

    itemImagesHtml += '%;">';
    itemImagesHtml +=
      '<img id="' +
      imgId +
      '" ' +
      'class="grid-view-item__image lazyload" ' +
      'src="' +
      Utils.getFeaturedImage(images, '300x300') +
      '" ' +
      'data-src="' +
      Utils.getFeaturedImage(images, '{width}x') +
      '" ' +
      'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
      'data-aspectratio="' +
      aspect_ratio +
      '" ' +
      'style="max-height: 100%;" ' +
      'data-sizes="auto" ' +
      'alt="{{itemTitle}}">';

    var appOnlyFlg =
      data?.metafields.find(
        (metafield) => metafield.key === 'app-only' && metafield.namespace === 'custom',
      )?.value === 'true'
        ? true
        : false;

    if (appOnlyFlg === true) {
      itemImagesHtml += '<span class="grid__item__image_tag">アプリ限定</span>';
    }

    itemImagesHtml += '</div>';
    itemImagesHtml += '</div>';

    var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
    var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
    itemImagesHtml +=
      '<noscript><img class="grid-view-item__image" src="' +
      Utils.getFeaturedImage(images, image_size + '@2x') +
      '" alt="{{itemTitle}}" style="max-width: ' +
      max_width +
      'px;"></noscript>';

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Review
    var itemReviewHtml = buildReview(data);
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

    var titleData = data.title;
    var repaceOne = 'ウィメンズ';
    var repaceTwo = 'メンズ';

    if (titleData.indexOf(repaceTwo) !== -1) {
      var titleTwoLine = titleData.split(repaceTwo);
      titleData = titleTwoLine[0] + '<br/>' + repaceTwo;
    }

    if (data.title.indexOf(repaceOne) !== -1) {
      var titleTwoLine = data.title.split(repaceOne);
      titleData = titleTwoLine[0] + '<br/>' + repaceOne;
    }

    itemHtml = itemHtml.replace(/{{itemTitle}}/g, titleData);
    // itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);

    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);

    var itemUrl = Utils.buildProductItemUrl(data).replace(/collections\/.+\/products/g, 'products');
    if (boostPFSAppConfig?.general?.collection_handle?.length > 0) {
      // itemUrl = itemUrl.replace(/products/g, 'collections/'+boostPFSAppConfig.general.collection_handle+'/products');
      localStorage.setItem(
        'prev_collection',
        JSON.stringify({
          url: '/collections/' + boostPFSAppConfig.general.collection_handle,
          title: boostPFSAppConfig.general.collection_title,
        }),
      );
    }
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemUrl);

    // var itemWishlistHtml = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '"></button>';
    // itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    itemHtml = itemHtml.replace(/{{tagDisplay}}/g, 'block');
    itemHtml = itemHtml.replace(/{{tagLimitedDisplay}}/g, 'flex');

    let tagLimitedHTML = '';

    if (data?.tags?.length > 0 && data.tags.includes('ベストセラー')) {
      tagLimitedHTML += `<span>ベストセラー</span>`;
    }
    if (data?.tags?.length > 0 && data.tags.includes('直営店限定モデル')) {
      tagLimitedHTML += `<span>直営店限定モデル</span>`;
    }
    if (data?.tags?.length > 0 && data.tags.includes('フェアトレード認証')) {
      tagLimitedHTML += `<span>フェアトレード認証</span>`;
    }

    // if(tagLimitedHTML !== ''){
    // 	itemHtml = itemHtml.replace(/{{tagLimitedColor}}/g, 'inherit');
    // 	itemHtml = itemHtml.replace(/{{tagLimitedText}}/g, tagLimitedHTML);
    // 	itemHtml = itemHtml.replace(/{{tagLimitedStatus}}/g,'is-shown');
    // }else{
    // 	itemHtml = itemHtml.replace(/{{tagLimitedColor}}/g, 'transparent');
    // 	itemHtml = itemHtml.replace(/{{tagLimitedText}}/g, '&nbsp;');
    // 	itemHtml = itemHtml.replace(/{{tagLimitedStatus}}/g,'not-shown');
    // }

    // 2025.3.2 Add
    // let limitedTagsHtml = '';
    // data.tags.forEach(tag => {
    // 	if (tag.startsWith('tag_')) {
    // 		const tagDatas = tag.split('_');
    // 		const tagColor = tagDatas[1];
    // 		const tagText = tagDatas[3];
    // 		if(tagText === "NEW") {
    // 			limitedTagsHtml += `<div class="grid__item__tags__tag is-shown" style="color: ${tagColor};">${tagText}</div>`;
    // 		}
    // 	} else if (tag === 'Badge_Revised') {
    // 		limitedTagsHtml += `<div class="grid__item__tags__tag is-shown" style="color: #B51818;">REVISED</div>`;
    // 	} else if (tag === 'Badge_DW') {
    // 		limitedTagsHtml += `<div class="grid__item__tags__tag is-shown" style="color: #B51818;">10年保証</div>`;
    // 	}
    // });

    // DLD タグ表示
    let limitedTagsHtml = '';
    let hasDW = false;
    let hasRevised = false;
    let newTagHtml = '';

    data.tags.forEach((tag) => {
      if (tag.startsWith('tag_')) {
        const tagDatas = tag.split('_');
        const tagColor = tagDatas[1];
        const tagText = tagDatas[3];

        if (tagText === 'NEW') {
          newTagHtml += `<div class="grid__item__tags__tag is-shown" style="color: ${tagColor};">${tagText}</div>`;
        }
      } else if (tag === 'Badge_DigitalWarranty') {
        hasDW = true;
      } else if (tag === 'Badge_Revised') {
        hasRevised = true;
      }
    });
    limitedTagsHtml += newTagHtml;
    if (hasRevised) {
      limitedTagsHtml += `<div class="grid__item__tags__tag is-shown" style="color: #B51818;">REVISED</div>`;
    }
    if (hasDW) {
      limitedTagsHtml += `<div class="grid__item__tags__tag is-shown" style="color: #B51818;">10年保証</div>`;
    }
    // DLD タグ表示 ここまで

    if (limitedTagsHtml === '') {
      limitedTagsHtml = `<div class="grid__item__tags__tag not-shown" style="color: transparent;">&nbsp;</div>`;
    }
    itemHtml = itemHtml.replace(/{{itemLimitedTags}}/g, limitedTagsHtml);
    if (data.metafields.length) {
      itemHtml = itemHtml.replace(/{{itemDescription}}/g, data.metafields[0].value);
    } else {
      itemHtml = itemHtml.replace(/{{itemDescription}}/g, '<div style="display:none"></div>');
    }

    var itemImagesHtmlVariant = '<div class="multiple-items multiple-items-slide-1">';
    var imgArr = [];
    if (data.variants) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].image) {
          if (imgArr.indexOf(data.variants[i].image) == -1) {
            imgArr.push(data.variants[i].image);
          }
        } else {
          if (imgArr.indexOf(data.images[1]) == -1) {
            imgArr.push(data.images[1]);
          }
        }
      }
    }

    if (imgArr) {
      for (var i = 0; i < imgArr.length; i++) {
        itemImagesHtmlVariant +=
          '<div class="a-slider" data-img=' +
          imgArr[i] +
          ' style="background-image: url(' +
          imgArr[i] +
          ')"></div>';
      }
    }

    itemImagesHtmlVariant += '</div>';

    itemHtml = itemHtml.replace(/{{variantImgs}}/g, itemImagesHtmlVariant);

    return itemHtml;
  };

  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml;

    // Add onSale label
    var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Thumbnail
    var itemThumbUrl =
      images.length > 0
        ? Utils.optimizeImage(images[0]['src'], '600x600')
        : boostPFSConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorSmallListHtml
      : '';
    itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
    var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorMediumListHtml
      : '';
    itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    var titleData = data.title;
    var repaceOne = 'ウィメンズ';
    var repaceTwo = 'メンズ';

    if (titleData.indexOf(repaceTwo) !== -1) {
      var titleTwoLine = titleData.split(repaceTwo);
      titleData = titleTwoLine[0] + '<br/>' + repaceTwo;
    }

    if (data.title.indexOf(repaceOne) !== -1) {
      var titleTwoLine = data.title.split(repaceOne);
      titleData = titleTwoLine[0] + '<br/>' + repaceOne;
    }

    itemHtml = itemHtml.replace(/{{itemTitle}}/g, titleData);
    // itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);

    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
  };

  // Build Image style
  function buildImageStyle(data) {
    var images = data.images_info;
    var imgId = 'ProductCardImage-' + data.id;
    var wrapperId = 'ProductCardImageWrapper-' + data.id;
    var imageStyle = '';
    if (images.length > 0) {
      var image = images[0];
      var width = boostPFSConfig.custom.max_height;
      var height = boostPFSConfig.custom.max_height;
      var aspect_ratio = image.width / image.height;
      var small_style = true;
      var container_aspect_ratio = (width * 1.0) / height;

      if (image.aspect_ratio < 1.0) {
        var maximum_width = height * aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          maximum_width = image.width;
        } else {
          var maximum_height = height;
        }
      } else if (aspect_ratio < container_aspect_ratio) {
        var maximum_height = height / aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_height = height;
          var maximum_width = height * aspect_ratio;
        }
      } else {
        var maximum_height = height / aspect_ratio;
        if (image.width <= width) {
          maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_width = width;
          maximum_height = maximum_width / aspect_ratio;
        }
      }

      imageStyle += '<style>';
      if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
      imageStyle +=
        '#' +
        imgId +
        ' {' +
        'max-width: ' +
        maximum_width +
        'px;' +
        'max-height: ' +
        maximum_height +
        'px;' +
        '}' +
        '#' +
        wrapperId +
        ' {' +
        'max-width: ' +
        maximum_width +
        'px;' +
        'max-height: ' +
        maximum_height +
        'px;' +
        '}';
      if (small_style) imageStyle += '}';

      if (small_style) {
        if (aspect_ratio < 1) {
          maximum_width = 750 * aspect_ratio;
        } else {
          if (image.width < 750) {
            maximum_width = image.width;
          } else {
            maximum_width = 750;
          }
        }
        // imageStyle += '@media screen and (max-width: 749px) {'
        // imageStyle += '#' + imgId + ' {' +
        // 	'max-width: ' + maximum_width + 'px;' +
        // 	'max-height: 750px;' +
        // 	'}' +
        // 	'#' + wrapperId + ' {' +
        // 	'max-width: ' + maximum_width + 'px;' +
        // 	'}';
        // imageStyle += '}';

        imageStyle += '@media screen and (max-width: 749px) {';
        imageStyle +=
          '#' +
          imgId +
          ' {' +
          'max-width: ' +
          maximum_width +
          'px;' +
          'max-height: ' +
          maximum_height +
          'px;' +
          '}' +
          '#' +
          wrapperId +
          ' {' +
          'max-width: ' +
          maximum_width +
          'px;' +
          '}';
        imageStyle += '}';
      }
      imageStyle += '</style>';
    }

    return imageStyle;
  }

  // prime review
  // function buildReview(data) {
  //   var reviewCount = 0;
  //   var reviewRating = 0;
  //   var reviewSummary =
  //     data?.metafields.find(
  //       (metafield) => metafield.key === 'summary' && metafield.namespace === 'prime_review',
  //     )?.value || null;
  //   if (reviewSummary) {
  //     reviewSummary = JSON.parse(reviewSummary);
  //     reviewCount = reviewSummary.total_count;
  //     reviewRating = reviewSummary.stars;
  //   }

  //   var fontSize = 16;
  //   var reviewHtml = `
  // 	<div class="star-ratings-css-top-wrapper">
  // 		<div class="star-ratings-css" style="font-size: ${fontSize}px; width: ${fontSize * 5}px;">
  // 			<div class="star-ratings-css-top" style="width: ${(reviewRating * 100) / 5}%; color: #990000;"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
  // 			<div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
  // 		</div>
  // 		<span class="star-ratings-css-top-review-count" style="font-size: ${fontSize}px;">
  // 			(${reviewCount})
  // 		</span>
  // 	</div>
  // 	`;

  //   return reviewHtml;
  // }

  // leeep
  function buildReview(data) {
    return `
    <div class="LeeepReviewScoreMarker c_leeep-review" data-product-id="${data.id}"></div>
  `;
  }

  function buildPrice(data, onSale, priceVaries) {
    var priceHtml = '',
      onSaleClass = onSale ? ' price--on-sale' : '';

    priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
    if (boostPFSConfig.custom.vendor_enable) {
      priceHtml += '<div class="price__vendor">';
      priceHtml += '<dt>';
      priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
      priceHtml += '</dt>';
      priceHtml += '<dd>';
      priceHtml += data.vendor;
      priceHtml += '</dd>';
      priceHtml += '</div>';
    }
    priceHtml += '<div class="price__regular">';
    priceHtml += '<dt>';
    priceHtml +=
      '<span class="visually-hidden visually-hidden--inline">' +
      boostPFSConfig.label.regular_price +
      ' (税込)' +
      '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
    // if (data.available) {
    if (onSale) {
      priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + ' (税込)';
    } else {
      priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat) + ' (税込)';
    }
    // } else {
    // 	priceHtml += boostPFSConfig.label.sold_out;
    // }
    priceHtml += '</span>';
    priceHtml += '</dd>';
    priceHtml += '</div>';
    priceHtml += '<div class="price__sale">';
    priceHtml += '<dt>';
    priceHtml +=
      '<span class="visually-hidden visually-hidden--inline">' +
      boostPFSConfig.label.sale_price +
      ' (税込)' +
      '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
    priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat) + ' (税込)';
    priceHtml += '</span> ';
    priceHtml +=
      '<span class="price-item__label" aria-hidden="true">' + boostPFSConfig.label.sale + '</span>';
    priceHtml += '</dd>';
    priceHtml += '<div class="price__compare">';
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden visually-hidden--inline">通常価格</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<s class="price-item price-item--regular">';
    priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + ' (税込)';
    priceHtml += '</s>';
    priceHtml += '</dd>';
    priceHtml += '</div>';

    priceHtml += '</div>';
    priceHtml += '</dl>';
    try {
      var product = Appmate.wk.getProduct(data.id);
      if (product == null) {
        priceHtml +=
          '<button type="button" class="wk-button-collection wk-add-product" title="Add to Wishlist" data-wk-add-product="' +
          data.id +
          '"><div class="wk-icon">';
        priceHtml +=
          '<svg version="1.1" xmlns="https://www.w3.org/2000/svg" width="64px" height="60.833px" viewBox="0 0 64 60.833">';
        priceHtml +=
          '<path stroke="#000" stroke-width="5" stroke-miterlimit="10" fill-opacity="0" d="M45.684,2.654c-6.057,0-11.27,4.927-13.684,10.073 c-2.417-5.145-7.63-10.073-13.687-10.073c-8.349,0-15.125,6.776-15.125,15.127c0,16.983,17.134,21.438,28.812,38.231 c11.038-16.688,28.811-21.787,28.811-38.231C60.811,9.431,54.033,2.654,45.684,2.654z"></path>';
        priceHtml += '</svg></div><span class="wk-label">Add to Wishlist</span></button>';
      } else {
        priceHtml +=
          '<button type="button" class="wk-button-collection wk-remove-product" title="Remove from Wishlist" data-wk-remove-product="' +
          data.id +
          '"><div class="wk-icon">';
        priceHtml +=
          '<svg version="1.1" xmlns="https://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">';
        priceHtml +=
          '<path d="M47.199 4c-6.727 0-12.516 5.472-15.198 11.188-2.684-5.715-8.474-11.188-15.201-11.188-9.274 0-16.8 7.527-16.8 16.802 0 18.865 19.031 23.812 32.001 42.464 12.26-18.536 31.999-24.2 31.999-42.464 0-9.274-7.527-16.802-16.801-16.802z" fill="#000"></path>';
        priceHtml += '</svg></div><span class="wk-label">In Wishlist</span></button>';
      }
      var product = Appmate.wk.getProduct(data.id);
    } catch {
      console.log('error wishlist king app');
    }

    return priceHtml;
  }

  function buildPromotionBanner() {
    const products_per_page = boostPFSThemeConfig.custom.products_per_page;
    const promotion_contents = boostPFSThemeConfig.custom.promotion_contents;
    const currentPage = parseInt(Globals.queryParams.page);

    function insertBanner(
      banner_position,
      banner_image,
      banner_aspect_ratio,
      banner_title,
      banner_link,
      banner_link_text,
      banner_text_color_light,
      banner_button_color_light,
      banner_text_button_small,
    ) {
      const banner_page = Math.ceil(banner_position / products_per_page);
      const banner_page_position = banner_position % products_per_page;

      if (!banner_image || banner_page !== currentPage) {
        return;
      }

      const target_elem = document.querySelectorAll(`.grid__item`)[banner_page_position - 1];
      const rendered_elem = document.querySelector(
        `.grid__item--banner[data-banner_position="${banner_page_position}"]`,
      );
      if (target_elem && !rendered_elem) {
        const banner_content = `
          ${banner_title ? `<h3 class="grid-banner__title">${banner_title}</h3>` : ''}
          ${
            banner_link_text
              ? `
            <button type="button" class="grid-banner__button btn">
              ${banner_link_text}
            </button>
          `
              : ''
          }
        `;
        const banner_html = `
          <div class="grid__item grid__item--banner small--one-half medium-up--one-quarter boost-pfs-action-list-enabled boost-pfs-action-list-single-button
            ${banner_text_color_light === true ? ' text-color--light' : ''}
            ${banner_button_color_light === true ? ' button-color--light' : ''}
            ${banner_text_button_small === true ? ' content--small' : ''}
            "
            data-banner_position="${banner_page_position}" >
          ${
            banner_link
              ? `
            <a href="${banner_link}" class="grid-view-item  product-card grid-banner"
              ${banner_image ? `style="background-image:url('${banner_image}'); aspect-ratio:${banner_aspect_ratio}; height: auto;` : ''}"
            >
              ${banner_content}
            </a>
          `
              : `
              <div class="grid-view-item  product-card grid-banner"
                ${banner_image ? `style="background-image:url('${banner_image}'); aspect-ratio:${banner_aspect_ratio}; height: auto;` : ''}"
              >
                ${banner_content}
              </div>
          `
          }
          </div>
        `;
        target_elem.insertAdjacentHTML('beforebegin', banner_html);
      }
    }

    // Banner 1
    if (promotion_contents?.banner1_position) {
      insertBanner(
        parseInt(promotion_contents.banner1_position),
        promotion_contents.banner1_image,
        promotion_contents.banner1_aspect_ratio,
        promotion_contents.banner1_title,
        promotion_contents.banner1_link,
        promotion_contents.banner1_link_text,
        promotion_contents.banner1_text_color_light,
        promotion_contents.banner1_button_color_light,
        promotion_contents.banner1_text_button_small,
      );
    }
    // Banner 2
    if (promotion_contents?.banner2_position) {
      insertBanner(
        parseInt(promotion_contents.banner2_position),
        promotion_contents.banner2_image,
        promotion_contents.banner2_aspect_ratio,
        promotion_contents.banner2_title,
        promotion_contents.banner2_link,
        promotion_contents.banner2_link_text,
        promotion_contents.banner2_text_color_light,
        promotion_contents.banner2_button_color_light,
        promotion_contents.banner2_text_button_small,
      );
    }
    // Banner 3
    if (promotion_contents?.banner3_position) {
      insertBanner(
        parseInt(promotion_contents.banner3_position),
        promotion_contents.banner3_image,
        promotion_contents.banner3_aspect_ratio,
        promotion_contents.banner3_title,
        promotion_contents.banner3_link,
        promotion_contents.banner3_link_text,
        promotion_contents.banner3_text_color_light,
        promotion_contents.banner3_button_color_light,
        promotion_contents.banner3_text_button_small,
      );
    }
    // Banner 4
    if (promotion_contents?.banner4_position) {
      insertBanner(
        parseInt(promotion_contents.banner4_position),
        promotion_contents.banner4_image,
        promotion_contents.banner4_aspect_ratio,
        promotion_contents.banner4_title,
        promotion_contents.banner4_link,
        promotion_contents.banner4_link_text,
        promotion_contents.banner4_text_color_light,
        promotion_contents.banner4_button_color_light,
        promotion_contents.banner4_text_button_small,
      );
    }
  }

  /// Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;

    // Build Previous
    var previousHtml =
      currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink('page', currentPage, currentPage - 1),
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml =
      currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink('page', currentPage, currentPage + 1),
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Build page items
    var currentPage = boostPFSConfig.label.current_page
      .replace(/{{ current }}/g, currentPage)
      .replace(/{{ total }}/g, totalPage);
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        if ('relevance' in sortingArr) {
          delete sortingArr['best-selling'];
        }
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    var itemHtml = '<span>View As </span>';
    itemHtml +=
      '<a href="' +
      Utils.buildToolbarLink('display', 'list', 'grid') +
      '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
    itemHtml +=
      '<a href="' +
      Utils.buildToolbarLink('display', 'grid', 'list') +
      '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

    return itemHtml;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    var productSelector = jQ(Selector.products);
    if (Globals.queryParams.display == 'list') {
      if (productSelector.children('.list-view-items').length == 0) {
        productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
      }
      productSelector.removeClass('grid grid--uniform grid--view-items');
    } else {
      if (productSelector.children('.list-view-items').length > 0) {
        productSelector.children('.list-view-items').children().unwrap();
      }
      productSelector.addClass('grid grid--uniform grid--view-items');
    }

    /** Start Swym integration **/
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      // Wrap with callback for loading without additional checks
      var products = [];
      data.forEach(function (product) {
        var image_src = Utils.getFeaturedImage(product.images_info);
        var productCopy = product;
        productCopy.featured_image = image_src;
        productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
        productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
        products.push(productCopy);
      });
      swat.mapShopifyProducts(products); // Product mapped data to swym layer
      swat.initializeActionButtons(Selector.products); // Buttons can now be initialized
    });
    /** End Swym integration **/

    // // Integrate Stamped.io Reviews
    // var self = this;
    // if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function') {
    // 	StampedFn.loadBadges();
    // }

    // Slick variant images
    $('.multiple-items-slide-1').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
    });

    $('.multiple-items-slide-1 .slick-track .a-slider').on('click', function (event) {
      var productItem = $(this).closest('.grid__item');
      productItem
        .find('.grid-view-item .grid-view-item__image-wrapper img')
        .attr('src', $(this).attr('data-img'));
      productItem
        .find('.grid-view-item .grid-view-item__image-wrapper img')
        .attr('data-srcset', $(this).attr('data-img'));
      productItem
        .find('.grid-view-item .grid-view-item__image-wrapper img')
        .attr('srcset', $(this).attr('data-img'));
    });

    // Leeep init IIFEの一度だけ定義
    if (!window.__initLeeepDebounced) {
      (function () {
        let leeepInitTimer = null;

        function initLeeep() {
          if (!document.getElementById('leeep-tag-1465262525254778880')) return;
          if (!window.LeeepCite || typeof window.LeeepCite.init !== 'function') return;

          try {
            window.LeeepCite.init({ tag_id: '1465262525254778880' });
          } catch (e) {}
        }

        window.__initLeeepDebounced = function () {
          clearTimeout(leeepInitTimer);
          leeepInitTimer = setTimeout(initLeeep, 150);
        };
      })();
    }
    if (window.__initLeeepDebounced) window.__initLeeepDebounced();
  };

  // Build Additional Elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    var totalProduct = '';
    if (data.total_product == 1) {
      totalProduct = boostPFSConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product,
      );
    } else {
      totalProduct = boostPFSConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product,
      );
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);

    buildPromotionBanner(data);

    // Leeep
    if (window.__initLeeepDebounced) window.__initLeeepDebounced();
  };

  FilterApi.beforeCall = function (eventType, eventInfo) {
    var keyParams = Object.keys(Globals.queryParams);
    var isFiltered = typeof keyParams.find((e) => e.indexOf('pf_') === 0) === 'undefined';
    var collection_initial_non_filtered =
      boostPFSAppConfig?.general?.collection_initial_non_filtered;
    if (
      !Utils.isSearchPage() &&
      isFiltered &&
      eventType === 'init' &&
      collection_initial_non_filtered !== 'true'
    ) {
      Globals.queryParams['pf_st_zai_ku'] = ['true'];
    }
  };
})();
